import { Observable } from 'rxjs';
import { RequestCustomer } from './../request-customer';

export abstract class CustomerGateway {
    abstract getCustomer(requestCustomer: RequestCustomer): Observable<any>;
}